\:host
    width: 100%

.OuterContainer
    position: relative
    overflow: visible

.Disabled
    background: rgb($globalSettingsBackgroundSecondary)
    cursor: auto

.SelectContainer
    position: relative
    min-width: 100%
    height: 40px
    box-sizing: border-box
    border: 1px rgb($globalSettingsStrokeSecondary) solid
    border-radius: 0 $globalButtonRounding $globalButtonRounding $globalButtonRounding
    display: flex
    flex-direction: row
    justify-content: space-between
    align-items: center
    margin: 0
    padding: 0 15px
    box-shadow: $globalButtonShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalButtonShadowSecondary rgba($globalSettingsBackgroundShadowColor,0.05)
    stroke: rgb($globalSettingsFontSecondary)
    cursor: pointer
    gap: 10px
    &:hover
        border-color: rgb($globalSettingsStrokePrimary)
    &:focus
        outline: none
        border-color: rgb($globalSettingsStrokePrimary)

.Disabled
    background: rgb($globalSettingsBackgroundSecondary)
    cursor: auto
    &:hover
        border-color: rgb($globalSettingsStrokeSecondary)
    &:focus
        outline: none
        border-color: rgb($globalSettingsStrokeSecondary)

.SelectLabel
    position: absolute
    font-size: 12px
    top: -1em
    left: 0
    height: 1em
    line-height: 1em
    z-index: 1
    display: inline-block
    vertical-align: text-top
    padding: 0 2px 0 0
    font-weight: 700
    pointer-events: none
    color: rgb($globalSettingsFontTertiary)
    white-space: nowrap
    user-select: none
    border-bottom: 1px solid rgb($globalSettingsBackgroundPrimary)
    box-sizing: border-box

.LeftInner
    min-width: 0
    display: flex
    flex-direction: row
    justify-content: center
    align-items: center
    flex-wrap: nowrap
    gap: 10px
    .DateContainer
        margin: 0
        padding: 0
        min-width: 0
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis
        svg
            margin: 0 5px
            stroke: rgb($globalSettingsFontPrimary)

.ExpandedContainerOuter
    width: 100%
    min-width: 320px
    position: absolute
    left: 0
    top: 50px
    padding-bottom: 20px
    z-index: $indexPicker
    display: flex
    flex-direction: column
    &.Right
        left: auto
        right: 0

.ExpandedContainer
    width: 100%
    background: rgb($globalSettingsBackgroundPrimary)
    margin: 0
    padding: 0
    border: 1px rgb($globalSettingsStrokeSecondary) solid
    border-radius: $globalButtonRounding
    box-sizing: border-box

svg
    flex-shrink: 0

.Error
    color: rgb($globalErrorBackground)

.NotValid
    .SelectLabel
        color: rgb($globalErrorBackground)
    svg
        stroke: rgb($globalErrorBackground)
